ParentDialogHandler = App.loadClass 'portal::handlers/convert/Parent_Dialog_Handler'

class exports.Convert_Dialog_Handler extends ParentDialogHandler

    init: () ->
        @reportAjax = 'backend/portal/convert/get-data'
        @layoutUrl = 'backend/portal/convert/load-layout-dialog'
        @exportUrl = 'backend/portal/convert/export'
        @saveUrl = 'backend/portal/convert/save-contracts'
        super()

    ###
    Datatables fnRowCallback used to build the datatable report
    ###
    rowCallback: (row, data) ->
        $(row).addClass 'plan-row tr-no-bottom-margin'
        $('td:eq(0)', row).html("<input type='checkbox' name='autofill' class='chk-copy'>")
        $('td:eq(1)', row).html("<span class='labels-vertical-pad'>#{data[1]}</span>")

        $('td:eq(2)', row).html("<span class='labels-vertical-pad' title='#{data[2]}'>#{data[2]}</span>")
        $('td:eq(2)', row).addClass 'convert-field-name'

        $('td:eq(3)', row).html("<input type='text' name='plan_acres' disabled='disabled' class='input-mini txt-plan-acres ' value='#{data[3]}'></input>")
        $('td:eq(3)', row).addClass 'normal-line'

        $('td:eq(4)', row).html("<input type='text' name='plan_brand' disabled='disabled' class='input-mini' value='#{data[4]}'></input>")
        $('td:eq(5)', row).html("<input type='text' name='plan_pop' disabled='disabled' class='input-mini txt-plan-pop ' value='#{data[5]}'></input>")
        $('td:eq(6)', row).html("<input type='text' name='plan_pot' disabled='disabled' class='input-mini txt-plan-yield ' value='#{data[6]}'></input>")
        $('td:eq(7)', row).html("<div class='crazy-arrow-line td-version'></div><div class='copy-btn btn btn-primary'><i class='fa fa-arrow-right'></i></div>")
        $('td:eq(8)', row).html("<input type='text' name='actual_acres' class='input-mini txt-actual-acres ' data-orig='#{data[8]}' value='#{data[8]}'></input>")
        $('td:eq(9)', row).html("<input type='text' name='actual_pop' class='input-mini txt-actual-pop ' data-orig='#{data[9]}' value='#{data[9]}'></input>")

        $('td:eq(10)', row).html("<input type='text' name='actual_date' class='input-mini txt-actual-date ' data-orig='#{data[10]}' value='#{data[10]}'></input>")
        $('td:eq(10)', row).find('.txt-actual-date').datepicker()

        $('td:eq(11)', row).html("<div class='input-append'><input type='text' name='actual_percent' class='txt-actual-percent input-mini' data-orig='#{data[11]}' value='#{data[11]}'><div class='add-on'> % </div></div>")
        $('td:eq(12)', row).html("<input type='text' name='actual_est' disabled='disabled' class='input-mini txt-actual-yield ' data-orig='#{data[12]}' value='#{data[12]}'></input>")

    saveStub: () ->
        @dialog.find('.errorDiv').hide()
        @dialog.find('.mfvalidate-invalid').removeClass('mfvalidate-invalid')

        doSave = true
        @saveData['toDelete'] = []
        @saveData['toAdd'] = []

        for row in @dialog.find('.plan-row')
            row = $(row)
            fcid = row.attr('id')
            acres = row.find('.txt-actual-acres').val()
            pop = row.find('.txt-actual-pop').val()
            date = row.find('.txt-actual-date').val()
            percent = row.find('.txt-actual-percent').val()

            if not acres and not pop and not date and not percent
                @saveData['toDelete'].push fcid
            else if acres and pop and date and percent
                # is this a valid date?
                if not Date.parse(date) or not date.match(/^\d+\/\d+\/\d+$/)
                    # highlight the erronous date in red
                    row.find('.txt-actual-date').addClass('mfvalidate-invalid')
                    # don't continue saving
                    doSave = false
                else
                    # everything seems valid, add the row to the data which should be saved
                    @saveData['toAdd'].push
                        fc_id: fcid
                        acres: acres
                        pop: pop
                        date: date
                        percent: percent
            else
                row.find('.txt-actual-acres').addClass('mfvalidate-invalid') if not acres
                row.find('.txt-actual-pop').addClass('mfvalidate-invalid') if not pop
                row.find('.txt-actual-date').addClass('mfvalidate-invalid') if not date
                row.find('.txt-actual-percent').addClass('mfvalidate-invalid') if not percent
                doSave = false

        if doSave
            for elem in @dialog.find('[data-orig]')
                $(elem).data('orig', $(elem).val())
            @saveData['toDelete'] = JSON.stringify @saveData['toDelete']
            @saveData['toAdd'] = JSON.stringify @saveData['toAdd']
            @save('Saving Planting Records')
        else
            @dialog.find('.errorDiv')
                .html('There were errors saving your data. Please correct the highlighted values and try again.')
                .show()
